// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KzT1","select":"styles_select__ao5m1"};